export default [
  {
    path: '/messagePin',
    name: 'messagePin',
    component: () => import('@/views/menu/messenger/messagePin/messagePin.vue'),
    meta: {
      pageTitle: 'پین کردن پیام ها',
      action: 'show',
      resource: 'BannerManager',
    },
  },
]
